import { useCallback, useEffect, useState } from "react";

const CountdownTimer = ({
  timerDuration,
  isSelfAssessmentStart,
  setSelfAssesmentStart,
  setOpenTimerIsUp,
}) => {
  const [countDownTime, setCountDownTime] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  const startCountDown = (isSelfAssessmentStart, timerDuration) => {
    const customDate = new Date();
    if (timerDuration === "30-minutes") {
      customDate.setSeconds(customDate.getSeconds() + 1801); // 30 minutes timer
    }

    const timerInterval = setInterval(() => {
      const currentTime = new Date().getTime();
      const timeDifference = customDate.getTime() - currentTime;
      let days =
        Math.floor(timeDifference / (24 * 60 * 60 * 1000)) >= 10
          ? Math.floor(timeDifference / (24 * 60 * 60 * 1000))
          : `0${Math.floor(timeDifference / (24 * 60 * 60 * 1000))}`;
      const hours =
        Math.floor(
          (timeDifference % (24 * 60 * 60 * 1000)) / (1000 * 60 * 60)
        ) >= 10
          ? Math.floor(
              (timeDifference % (24 * 60 * 60 * 1000)) / (1000 * 60 * 60)
            )
          : `0${Math.floor(
              (timeDifference % (24 * 60 * 60 * 1000)) / (1000 * 60 * 60)
            )}`;
      const minutes =
        Math.floor((timeDifference % (60 * 60 * 1000)) / (1000 * 60)) >= 10
          ? Math.floor((timeDifference % (60 * 60 * 1000)) / (1000 * 60))
          : `0${Math.floor((timeDifference % (60 * 60 * 1000)) / (1000 * 60))}`;
      const seconds =
        Math.floor((timeDifference % (60 * 1000)) / 1000) >= 10
          ? Math.floor((timeDifference % (60 * 1000)) / 1000)
          : `0${Math.floor((timeDifference % (60 * 1000)) / 1000)}`;
      if (timeDifference < 0 && isSelfAssessmentStart) {
        setCountDownTime({
          days: "00",
          hours: "00",
          minutes: "00",
          seconds: "00",
        });
        setOpenTimerIsUp(true);
        setSelfAssesmentStart(false);
        clearInterval(timerInterval);
      } else if (!isSelfAssessmentStart) {
        setCountDownTime({
          days: "00",
          hours: "00",
          minutes: "00",
          seconds: "00",
        });
        setOpenTimerIsUp(false);
        setSelfAssesmentStart(false);
        clearInterval(timerInterval);
      } else {
        setCountDownTime({
          days: days,
          hours: hours,
          minutes: minutes,
          seconds: seconds,
        });
      }
    }, 1000);
  };

  useEffect(() => {
    startCountDown(isSelfAssessmentStart, timerDuration);
  }, []);

  return (
    <div>
      <div className="flex flex-col justify-center items-center px-3 py-2 border border-black rounded-lg">
        <p className="text-center text-xs md:text-sm">Remaining Time:</p>
        <div className="text-2xl lg:text-3xl">
          <span>{countDownTime?.minutes}</span>:
          <span>{countDownTime?.seconds}</span>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
